import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from "react";

interface TopbarActionsState {
  actions: ReactNode | null;
  setActions: (node: ReactNode | null) => void;
}

const TopbarActionsContext = createContext<TopbarActionsState | null>(null);

export function TopbarActionsProvider({ children }: { children: ReactNode }) {
  const [actions, setActions] = useState<ReactNode | null>(null);
  const value = useMemo(() => ({ actions, setActions }), [actions]);
  return (
    <TopbarActionsContext.Provider value={value}>
      {children}
    </TopbarActionsContext.Provider>
  );
}

export function useTopbarActionsSlot(): ReactNode | null {
  return useContext(TopbarActionsContext)?.actions ?? null;
}

/** Mount page-specific controls in the topbar right slot (cleared on unmount). */
export function useTopbarActions(node: ReactNode | null): void {
  const ctx = useContext(TopbarActionsContext);
  if (!ctx)
    throw new Error(
      "useTopbarActions must be used inside TopbarActionsProvider"
    );
  const { setActions } = ctx;

  useEffect(() => {
    setActions(node);
    return () => setActions(null);
  }, [setActions, node]);
}
